import { render } from "./BookmarkIcon.vue?vue&type=template&id=74469675"
import script from "./BookmarkIcon.vue?vue&type=script&lang=js"
export * from "./BookmarkIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__